import ApiClient from '../../services/apiClient';
import { useQuery } from 'react-query';

const _apiClient = new ApiClient();

export const GET_USER_ANNOUNCEMENTS_KEY = 'get-user-announcements'

export const useGetUserAnnouncements = (enabled: boolean) => {
    return useQuery({
        queryKey: [GET_USER_ANNOUNCEMENTS_KEY],
        queryFn: async () => {
            const response = await _apiClient.getUserAnnouncements();

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve User Announcements.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        enabled: enabled,
    });
};
